import moment from "moment";
import {
  EMPLOYEE_GENERAL_STATUS,
  EMPLOYEE_STATUS,
  TGetEmployeeItem,
  TGetEmployeeItemUserFavorite,
  TGetEmployeesCollectionItem,
} from "../../../../../api/employee/employee.types";
import { ECandidateProfileTab } from "../types/candidate.types";

export const candidateIsFavoriteOfUser = (
  candidate: Pick<TGetEmployeeItem, "favoritedBy">,
): boolean => {
  const foundFav = candidate.favoritedBy?.length;
  return !!foundFav;
};

export const candidateFavoriteOfUser = (
  candidate: Pick<TGetEmployeeItem, "favoritedBy">
): TGetEmployeeItemUserFavorite | undefined => {
  return candidate.favoritedBy?.length ? candidate.favoritedBy[0] : undefined;
};

export const candidateIsInactive = (
  candidate: Pick<TGetEmployeesCollectionItem, "general_status">
): boolean => {
  return candidate.general_status === EMPLOYEE_GENERAL_STATUS.INACTIVE;
};

export const candidateHasSpanishBusinessCountry = (
  candidate: TGetEmployeesCollectionItem
): boolean => {
  if (candidate.Business_Country === "es") {
    return true;
  }
  return false;
};

export const candidateIsValidatedOrBetter = (
  candidate: TGetEmployeesCollectionItem
) => {
  if (
    candidate.Estado_Cuideo === EMPLOYEE_STATUS.VALIDATED ||
    candidate.Estado_Cuideo === EMPLOYEE_STATUS.VALIDATED_PLUS ||
    candidate.Estado_Cuideo === EMPLOYEE_STATUS.ACTIVE
  ) {
    return true;
  }

  return false;
};

export const candidateIdExpiryIsValid = (
  candidate: TGetEmployeesCollectionItem
) => {
  if (null === candidate.Vencimiento_NIE) {
    return false;
  }

  const expiryMom = moment(candidate.Vencimiento_NIE);
  const now = moment();
  if (expiryMom.isAfter(now)) {
    return true;
  }
  return false;
};

export const candidateShouldShowInvalidIdExpiryDateWarning = (
  candidate: TGetEmployeesCollectionItem
): boolean => {
  if (
    candidateIsValidatedOrBetter(candidate) &&
    candidateHasSpanishBusinessCountry(candidate) &&
    !candidateIdExpiryIsValid(candidate)
  ) {
    return true;
  }
  return false;
};

export const parseCandidateProfileTab = (
  value: unknown
): ECandidateProfileTab => {
  return Object.values(ECandidateProfileTab).includes(
    value as ECandidateProfileTab
  )
    ? (value as ECandidateProfileTab)
    : ECandidateProfileTab.PROFILE;
};
